import React, { useEffect, useRef } from 'react';
import './PopupTable.css'; // Link to CSS
import { dateTimeFormat } from '../../utils/Misc/DateTime';
import { useGlobalAppContext } from '../../context/Context';

const PopupTable = ({ data, marginTopClass = "" }) => {
  const popupRef = useRef(null);

  const { closeServiceTable } = useGlobalAppContext();

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      closeServiceTable();
    }
  };

  useEffect(() => {
    // Add event listener to document
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      // Clean up the event listener on component unmount
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div ref={popupRef} className={`popup-container ${marginTopClass}`}>
      {
        data.length &&
        <table className='popup-table'>
          <thead>
            <tr style={{position: "sticky", top: '0'}}>
              <th>Service</th>
              <th>Start Date</th>
              <th>End Date</th>
            </tr>
          </thead>
          <tbody>
            {data.map(({ SERVICE_SHORTNAME, STARTDATE, VALIDUPTO }) => (
              <tr key={SERVICE_SHORTNAME}>
                <td>{SERVICE_SHORTNAME}</td>
                <td>{dateTimeFormat(STARTDATE)}</td>
                <td>{dateTimeFormat(VALIDUPTO)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      }
    </div>
  )
}

export default PopupTable;